import { useContext, useEffect, useState, useRef } from 'react'
import { LanguageContext } from '../../context';
import Translate from '../Translate/Translate';
import { Link } from 'react-router-dom';
import './Navigation.css'
import deleteIcon from "../../Images/Header/delete.svg"

const Navigation = () => {

    const { language } = useContext(LanguageContext);
    const [isMenuOpen,setIsMenuOpen]=useState(false);
    const refClose=useRef(null);
    const refMenu=useRef(null);
    const hasMenuChanged=useRef(false);
    
    useEffect(() => {
        if (!hasMenuChanged.current) {
            return;
        }

        if (isMenuOpen) {
            refClose.current?.focus();
            return;
        }

        refMenu.current?.focus();
    }, [isMenuOpen]);

    const openMenu=()=>{
        hasMenuChanged.current=true;
        setIsMenuOpen(true);
    }

    const closeMenu=()=>{
        hasMenuChanged.current=true;
        setIsMenuOpen(false);
    }

    const handleMenuKeyDown=(e)=>{
        if(e.key==='Escape'){
            closeMenu();
        }
    }

    const handleCloseFocus=()=>{
        refClose.current?.focus();
    }

  return (
    <div className='navigation-container'>
        <button type="button" className='hamburger-icon' aria-haspopup="true" aria-expanded={isMenuOpen} aria-label="פתיחת תפריט ראשי" ref={refMenu}
                 onClick={openMenu}>&#9776;</button>
        <div className={`navigate-menu ${isMenuOpen ? 'open' : 'close'}`} onKeyDown={handleMenuKeyDown}> 
       
        <ul>
        <li><button type="button" className='close-button' aria-label="סגור תפריט ראשי" ref={refClose} onClick={closeMenu}>
                <img src={deleteIcon} alt="" /></button></li>
            <li> <Link to={`/${language}/about`}><Translate>About</Translate></Link></li>
            <li><Link to={`/${language}/developer`}><Translate>Developer</Translate></Link></li>
            <li> <Link to={`/${language}/accessibility`}><Translate>Accessibility</Translate></Link> </li>
            <li> <Link to={`/he/terms`}><Translate>CustomerAgreementTermsMenu</Translate></Link> </li>
            <li> <a href="https://www.tel-aviv.gov.il/About/Pages/PrivacyStatement.aspx" target='_blank' rel="noreferrer"><Translate>CustomerAgreementPrivacyMenu</Translate></a> </li>
            <li className='offset lastDivClose' tabIndex="0" onBeforeInput={handleCloseFocus} onFocus={handleCloseFocus}><Translate>MustCloseSection</Translate></li>	       
             </ul>


           
            
                 
        </div>
    </div>
  )
}

export default Navigation